/* Catalogue options are enquiry preferences; stock and purchase controls are separate. */
(() => {
  const init = () => document.querySelectorAll('[data-uh-configuration]').forEach(root => {
    if (root.dataset.ready) return;
    let data;
    try { data = JSON.parse(root.querySelector('[data-uh-config-data]').textContent); } catch { return; }
    if (!Array.isArray(data.variants) || !data.variants.length) return;
    root.dataset.ready = 'true';
    const english = document.documentElement.lang.startsWith('en');
    const speed = root.querySelector('[data-uh-speed]');
    const limiter = root.querySelector('[data-uh-limiter]');
    const colourInputs = [...root.querySelectorAll('[data-uh-colour]')];
    const reset = root.querySelector('[data-uh-config-reset]');
    const selected = () => data.variants.find(v => v.colour === colourInputs.find(i => i.checked)?.value && v.speed === Number(speed.value) && v.limited === (limiter?.value === '6'));
    const apply = (variant) => {
      colourInputs.forEach(i => { i.checked = i.value === variant.colour; });
      speed.value = String(variant.speed);
      if (limiter) limiter.value = variant.limited ? '6' : 'none';
    };
    const sync = (writeUrl = true) => {
      const v = selected();
      if (!v) return;
      const c = data.colours.find(c => c.name === v.colour);
      const speedText = v.limited ? `${v.speed} km/h · ${root.dataset.limitedLabel}` : `${v.speed} km/h`;
      const summary = [data.title, english ? c.name_en : c.name, speedText, english ? data.battery_en : data.battery].filter(Boolean).join(' · ');
      root.querySelector('[data-uh-config-summary]').textContent = summary;
      root.querySelector('[data-uh-variant-sku]').value = v.sku;
      root.querySelector('[data-uh-config-selection]').value = summary;
      const contact = document.querySelector('[data-uh-config-contact]');
      if (contact) { contact.hidden = false; contact.querySelector('[data-uh-config-contact-summary]').textContent = summary; }
      const model = document.getElementById('uh-contact-model');
      if (model) model.value = data.title;
      if (writeUrl) {
        const url = new URL(location.href);
        url.searchParams.set('konfiguration', v.sku);
        ['uh_colour', 'uh_speed', 'uh_limit'].forEach(key => url.searchParams.delete(key));
        history.replaceState(history.state, '', url);
      }
      root.querySelectorAll('[data-uh-battery-handle]').forEach(link => {
        const peer = data.battery_choices.find(b => b.handle === link.dataset.uhBatteryHandle);
        const url = new URL(link.href, location.href);
        url.searchParams.set('uh_colour', v.colour);
        url.searchParams.set('uh_speed', String(v.speed));
        const previewTheme = new URL(location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        if (peer?.current) url.searchParams.set('konfiguration', v.sku);
        link.href = url.href;
      });
      const source = document.querySelector('[data-uh-contact-source]');
      if (source) { const url = new URL(location.href); url.search = ''; url.hash = ''; url.searchParams.set('konfiguration', v.sku); source.value = url.href; }
      root.dispatchEvent(new CustomEvent('uh:configuration-change', {bubbles:true, detail:{sku:v.sku, modelSku:data.model_sku}}));
    };
    const restore = () => {
      const params = new URLSearchParams(location.search);
      const key = params.get('konfiguration');
      const exact = data.variants.find(v => v.sku === key);
      let v = exact;
      let resetNeeded = false;
      if (!v && (params.has('uh_colour') || params.has('uh_speed'))) {
        const requestedColour = params.get('uh_colour');
        const requestedSpeed = Number(params.get('uh_speed'));
        const colour = data.colours.some(c => c.name === requestedColour) ? requestedColour : data.colours[0].name;
        const chosenSpeed = data.speeds.includes(requestedSpeed) ? requestedSpeed : data.speeds[0];
        resetNeeded = colour !== requestedColour || chosenSpeed !== requestedSpeed;
        v = data.variants.find(v => v.colour === colour && v.speed === chosenSpeed && !v.limited);
      }
      if (key && !exact) resetNeeded = true;
      apply(v || data.variants[0]);
      reset.hidden = !resetNeeded;
      reset.textContent = resetNeeded ? root.dataset.resetMessage : '';
      sync(false);
    };
    root.addEventListener('change', e => { if (e.target.matches('[data-uh-colour],[data-uh-speed],[data-uh-limiter]')) { reset.hidden = true; sync(); } });
    window.addEventListener('popstate', restore);
    restore();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
